import cn from 'classnames';

import s from './Preloader.module.css';

export interface PreloaderProps {
  className?: string;
}

export function Preloader({className}: PreloaderProps): JSX.Element {
  return (
    <svg version="1.1" x="0" y="0" className={cn(s.svg, className)} viewBox="0 0 100 100">
      <circle className={s.circle} cx="50" cy="50" r="44" />
    </svg>
  );
}
